import { render, staticRenderFns } from "./taskDataTable.vue?vue&type=template&id=27e34692&"
import script from "./taskDataTable.vue?vue&type=script&lang=js&"
export * from "./taskDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports